module.exports = __webpack_public_path__ + "media/home/eStore_Icon_PartnerBenefits-c8f58310.png";